require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-what-can-the-world-bank-learn-about-child-seah-issues.json") })
        }
      }, "path---en-us-update-what-can-the-world-bank-learn-about-child-seah-issues");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-what-can-the-world-bank-learn-about-child-seah-issues!./.cache/json/en-us-update-what-can-the-world-bank-learn-about-child-seah-issues.json
// module id = 831
// module chunks = 231608221292675